<script setup lang="ts">
defineProps<{
  startDate: string;
  endDate: string;
}>()

const formatDate = (dateString: string): string => {
  const date = new Date(dateString)

  return new Intl.DateTimeFormat('en-US', {
    year: 'numeric',
    month: 'short',
    day: '2-digit',
  }).format(date)
}
</script>

<template>
  <sword-tag color="primary" icon="hourglass" class="w-full">
    {{ formatDate(startDate) }} - {{ formatDate(endDate) }}
  </sword-tag>
</template>
